//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import usersAPI from "./../apis/users";
import { Toast } from "./../utils/helpers";

export default {
  name: "Popular",
  props: {
    initialPopular: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      users: [],
    };
  },
  watch: {
    initialPopular: function () {
      this.fetchUsersTop();
    },
  },
  created() {
    this.fetchUsersTop();
  },
  methods: {
    async fetchUsersTop() {
      try {
        const response = await usersAPI.getUsersTop();
        const { data } = response.data;

        if (data.status === "error") {
          throw new Error(data.message);
        }

        this.users = data;
      } catch (error) {
        Toast.fire({
          icon: "warning",
          title: error.message,
        });
      }
    },

    async deleteFollow(userId) {
      try {
        const { data } = await usersAPI.deleteFollow({ userId });
        console.log(data);
        this.users = this.users.map((user) => {
          if (user.id !== userId) {
            return user;
          } else {
            return {
              ...user,
              isFollowed: false,
            };
          }
        });
        this.$emit("update-follows");

        // 即時更新當前使用者追蹤人數
        const currentUser = this.$store.state.currentUser;
        this.$store.dispatch("fetchCurrentUser", { payload: currentUser.id });
      } catch (error) {
        console.log(error);
      }
    },
    async addFollow(id) {
      try {
        const { data } = await usersAPI.addFollow({ id });
        console.log(data);
        this.users = this.users.map((user) => {
          if (user.id !== id) {
            return user;
          } else {
            return {
              ...user,
              isFollowed: true,
            };
          }
        });
        this.$emit("update-follows");

        // 即時更新當前使用者追蹤人數
        this.$store.dispatch("fetchCurrentUser");
      } catch (error) {
        console.log(error);
      }
    },
  },
};
